(() => {
  const query = document.querySelector('.header-full .cd-dropdown-content');
  if (!query) return;

  // creating wrappers for top and second level categories
  const topCatWrapper = document.createElement('div');
  topCatWrapper.classList.add('top-cat-wrapper');

  const secondCatWrapper = document.createElement('div');
  secondCatWrapper.classList.add('second-cat-wrapper');
  secondCatWrapper.innerHTML = '<div class="container"></div>';

  const topCats = query.querySelectorAll(':scope > li');
  const secondCats = query.querySelectorAll(':scope > li > ul');

  // appending top level categories to topCatWrapper
  topCats.forEach((cat) => {
    const catIcon = cat.querySelector('ul .nav-icon');
    const link = cat.querySelector('a');

    if (catIcon) {
      link.prepend(catIcon.querySelector('img'));
      catIcon.remove();
      link.classList.remove('hide');

      cat.querySelectorAll('.cd-secondary-dropdown.is-hidden').forEach((el) => {
        el.classList.remove('is-hidden');
      });

      cat.querySelectorAll('.cd-secondary-dropdown .hide').forEach((el) => {
        el.classList.remove('hide');
      });
    } else {
      link.classList.add('hide');
    }

    topCatWrapper.appendChild(link);
  });

  // appending second level categories to secondCatWrapper
  secondCats.forEach((cat) => {
    secondCatWrapper.querySelector('.container').appendChild(cat);
  });

  // Wrap each cd-secondary-dropdown in a wrapper and move li.has-image outside the ul
  secondCatWrapper.querySelectorAll('.container > ul.cd-secondary-dropdown').forEach((ul) => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('cd-secondary-dropdown-wrapper');

    if (ul.classList.contains('is-hidden')) {
      wrapper.classList.add('is-hidden');
    }

    ul.parentNode.insertBefore(wrapper, ul);
    wrapper.appendChild(ul);

    ul.querySelectorAll(':scope > li.has-image, :scope > li.nav-image').forEach((item) => {
      const div = document.createElement('div');
      div.classList.add('nav-image');
      const img = item.querySelector('img');

      if (img) {
        img.setAttribute('role', 'presentation');
        img.setAttribute('aria-hidden', 'true');
        div.appendChild(img);
      }

      wrapper.appendChild(div);
      item.remove();
    });
  });

  // appending wrappers to DOM
  query.insertAdjacentElement('afterbegin', secondCatWrapper);
  query.insertAdjacentElement('afterbegin', topCatWrapper);

  // removing top level categories from DOM
  query.querySelectorAll(':scope > li').forEach((li) => {
    li.remove();
  });

  query.querySelectorAll('.cd-secondary-dropdown > li.has-children > a').forEach((anchor) => {
    if (anchor.getAttribute('href') === '#') {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
      });
    }
  });

  /**
   *
   */
  (() => {
    const tierTwoTitle = Array.from(document.querySelectorAll('.top-cat-wrapper > a:not(.hide)'));
    const menus = document.querySelectorAll('.second-cat-wrapper .container > .cd-secondary-dropdown-wrapper:not(.is-hidden)');
    const dropdown = document.querySelector('.header-full .cd-dropdown');

    const resetPanels = () => {
      tierTwoTitle.forEach((el) => {
        el.classList.remove('active');
      });

      menus.forEach((menu) => {
        menu.classList.remove('active');
      });

      secondCatWrapper?.classList.remove('active');
    };

    const activateTab = (tab) => {
      if (!tab) return;

      resetPanels();
      tab.classList.add('active');

      const index = tierTwoTitle.indexOf(tab);

      if (menus[index]) {
        menus[index].classList.add('active');
        secondCatWrapper?.classList.add('active');
      }
    };

    tierTwoTitle.forEach((tierTwo) => {
      tierTwo.addEventListener('click', (e) => {
        e.preventDefault();

        if (tierTwo.classList.contains('active')) {
          resetPanels();
          return;
        }

        activateTab(tierTwo);
      });
    });

    if (dropdown) {
      const syncDropdownState = () => {
        if (dropdown.classList.contains('dropdown-is-active')) {
          const activeTab = tierTwoTitle.find((tab) => tab.classList.contains('active'));
          activateTab(activeTab || tierTwoTitle[0]);
          return;
        }

        resetPanels();
      };

      new MutationObserver(syncDropdownState).observe(dropdown, {
        attributes: true,
        attributeFilter: ['class'],
      });

      syncDropdownState();
    }
  })();
})();
